<style scoped>
.twoAn {
  color: #4fa1a4;
  font-size: 14px;
  margin-right: 10px;
}
.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  position: relative;
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
  height: 100%;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
/* ::v-deep .el-input--suffix .el-input__inner {
  width: 300px;
} */
.Showbox {
  margin-left: 120px;
  margin-top: -23px;
  border: 1px solid #c0c4cc;
  width: 300px;
  height: 100%;
}
/* 新增 */
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
.select-box {
  display: flex;
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.accentColor {
  color: #4fa1a4;
  margin-right: 12px;
}
.cost-content .el-table .el-table--fit {
  margin-left: 120px;
}
.mt20 .el-form-item__content {
  width: 830px;
}
::v-deep .el-pagination {
  display: flex !important;
  justify-content: center !important;
  margin-top: 8px !important;
}
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
</style>
<template>
  <div class="content">
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>{{ isAudit?'审批详情':disabled? '查看资料' :txt }}</span>
      <el-tag v-if="$route.query.isAudit" class="approve-tag" :type="type[approveState]" size="small" >{{ approveStateObj[approveState] }}</el-tag>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm mb54">
      <!--start 基础信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12"
              ><el-form-item label="公司名称" prop="tenantGuid">
                <el-select
                  v-model="ruleForm.tenantGuid"
                  :disabled="disabled || !!$route.query.guid"
                  placeholder="请选择"
                  filterable
                  class="w300"
                  @change="getStaffList(ruleForm.tenantGuid)"
                >
                  <el-option
                    v-for="item in tenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="商业公司名称" prop="franchiseeName">
                <el-input
                  v-model="ruleForm.franchiseeName"
                  :disabled="disabled"
                  @blur="checkName"
                  placeholder="请输入"
                  class="w300"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12">
              <el-form-item label="标注位置" prop="markers">
                <div class="map-a-sty" v-if="!ruleForm.markers && !disabled" @click="showMap">
                  <i class="el-icon-plus"></i> 选择地图
                </div>
                <div v-if="ruleForm.markers && !disabled" class="map-a-sty" @click="showMap">
                  <i class="el-icon-plus"></i> 重新选择
                </div>
                <div v-if="ruleForm.markers && ruleForm.markers.lat">
                  经度：{{ ruleForm.markers.lng || '' }}，纬度：{{ ruleForm.markers.lat || '' }}
                </div>
                <div v-else-if="disabled">-</div>
                <div v-if="!disabled" class="fontC-4fa1a4">提示：请确认定位准确，以免影响客户拜访定位</div>
              </el-form-item>
            </el-col>
            <el-col :span="12"
              ><el-form-item label="所属区域" prop="addressList">
                <el-cascader
                  ref="cascaderFirst"
                  v-model="ruleForm.addressList"
                  :disabled="disabled"
                  :options="options"
                  class="w300"
                  @change="incres"
                ></el-cascader> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="详细地址" prop="address">
                <el-input
                  type="textarea"
                  v-model="ruleForm.address"
                  :disabled="disabled"
                  placeholder="请输入"
                  class="w300"
                ></el-input> </el-form-item
            ></el-col>
            <!-- <el-col :span="12">
              <el-form-item label="启用状态">
                <el-radio-group class="w300" :disabled="disabled" v-model="ruleForm.bizState">
                  <el-radio label="Y">启用</el-radio>
                  <el-radio label="S">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="12"
              ><el-form-item label="商业公司类型" prop="property">
                <el-select v-model="ruleForm.property" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option
                    v-for="item in franchiseeTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="所在大区" prop="region">
                <el-select v-model="ruleForm.region" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in regionList" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select> </el-form-item
            ></el-col>
          </el-row>
        </div>
      </div>
      <!--end 基础信息 -->

      <!-- start of 联系人信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系人信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12"
              ><el-form-item label="联系人" prop="contacts">
                <el-input
                  ref="contactsRef"
                  @input="ruleForm.contacts = ruleForm.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, '')"
                  @blur="nameBlur(ruleForm.contacts, ruleForm, 'contacts')"
                  :disabled="disabled"
                  v-model="ruleForm.contacts"
                  class="w300"
                  placeholder="请输入"
                  clearable
                ></el-input> </el-form-item
            ></el-col>

            <el-col :span="12"
              ><el-form-item label="手机号码" prop="contactTel">
                <el-input
                  v-model="ruleForm.contactTel"
                  @input="ruleForm.contactTel = ruleForm.contactTel.replace(/[^\d\-\d]/g, '')"
                  :disabled="disabled"
                  class="w300"
                  maxlength="13"
                  placeholder="请输入"
                  clearable
                ></el-input> </el-form-item
            ></el-col>

            <el-col :span="12"
              ><el-form-item label="建档时间" required>
                <el-col :span="11">
                  <el-form-item prop="inputDate">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="ruleForm.inputDate"
                      :disabled="disabled"
                      class="w300"
                    ></el-date-picker>
                  </el-form-item>
                </el-col> </el-form-item
            ></el-col>
            <el-col :span="24">
              <el-form-item label="业务指派人员">
                <div class="addPeople" v-if="!disabled" @click="popupBox()"><i class="el-icon-plus"></i> 添加人员</div>
                <!-- 人员表格 -->
                <ChoosePerson
                  ref="choosePerson"
                  :showChoosePerson.sync="showChoosePerson"
                  :areaData="areaData"
                  :serviceTenants="serviceTenants"
                  :serviceTenantGuid="serviceTenantGuid"
                  :dialogLoading="dialogLoading"
                  :list="belongStaffList"
                  @getPerson="getPerson"
                >
                </ChoosePerson>
                <!-- 人员表格 -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系人信息 -->

      <div class="submit-btn-box submit_btn_wrap" v-if="!isAudit&&!disabled">
        <el-button type="defalut" size="small" @click="back()">取消</el-button>
        <el-button type="primary" size="small" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 2)"
          >提交</el-button
        >
        <el-button type="primary" size="small" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 2)"
          >提交</el-button
        >
        <el-button type="primary" size="small" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 1)"
          >添加下一个</el-button
        >
        <el-button type="primary" size="small" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 1)"
          >添加下一个</el-button
        >
      </div>
      <div class="operte-btns back-color-fff" v-if="isAudit">
        <el-button v-if="approveState=='A'" type="primary" size="small"  @click="toAudit()">审核</el-button>
        <el-button v-if="approveState=='Y'||approveState=='N'" type="primary" size="small"  @click="toAudit()">撤回重审</el-button>
        <el-button type="defalut" size="small"  @click="$router.go(-1)">返回</el-button>
      </div>
    </el-form>

    <!-- 弹框 -->
    <el-dialog title="选择地图" :visible.sync="dialogVisible" width="980px">
      <dialogMap ref="refMap" :markers="ruleForm.markers" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog>
    <AuditDialog @closeAudit="closeAudit"></AuditDialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import recentDate from '@/uilt/recentDate';
import ChoosePerson from './components/ChoosePerson';
import AuditDialog from './components/AuditDialog';
import mixins from './components/mixins/detailMixins.js';
export default {
  name: 'commercialCompanyinquiryDetail',
  components: {
    dialogMap,
    ChoosePerson,
    AuditDialog
  },
  mixins: [mixins],
  data() {
    return {
      showChoosePerson: false, // 人员选择
      belongStaffList: [], // 指派人员列表
      changebelongStaffList: [], // 修改后的指派人员
      belongStaffs: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRowss: 0,
      },
      pages: {
        pageIndex: 1,
        pageSize: 10,
        totalRowss: 0,
      },
      customerGuids: [],
      areaData: [], // 树状
      txt: '',
      dialogVisible: false,
      options: areaJson,
      fullscreenLoading: false,
      tenantList: [],
      serviceTenants: [],
      serviceTenantGuid: '',
      dialogLoading: false,
      ruleForm: {
        tenantGuid: '',
        franchiseeName: '',
        property: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        venue: '',
        createUserId: '',
        //业务指派人员
        bizState: 'Y', //启用状态
      },
      rules: {
        tenantGuid: [{ required: true, message: '请选择公司', trigger: 'blur' }],
        franchiseeName: [{ required: true, message: '请输入商业公司名称', trigger: 'blur' }],
        createUserId: [{ required: true, message: '请选择所属人员姓名', trigger: 'change' }],
        addressList: [
          {
            type: 'array',
            required: true,
            message: '请选择所属区域',
            trigger: 'change',
          },
        ],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        // contacts: [
        //   { required: true, message: '请输入联系人', trigger: 'blur' }
        // ],
        // contactTel: [
        //   { required: true, message: '请输入电话号码', trigger: 'blur' }
        // ],
        markers: [{ required: true, message: '请选择经纬度', trigger: 'blur' }],
        // property: [
        //   { required: true, message: "请选择商业公司类型", trigger: "change" },
        // ],
        inputDate: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      regionList: [
        {
          value: 'NE',
          name: '东北区',
        },
        {
          value: 'NC',
          name: '华北区',
        },
        {
          value: 'SC',
          name: '华南区',
        },
        {
          value: 'NW',
          name: '西北区',
        },
        {
          value: 'SW',
          name: '西南区',
        },
        {
          value: 'CC',
          name: '华中区',
        },
        {
          value: 'EC',
          name: '华东区',
        },
      ],
      franchiseeTypeList: [
        {
          value: '一级经销商',
          label: '一级经销商',
        },
        {
          value: '二级经销商',
          label: '二级经销商',
        },
        {
          value: '垂直商业公司',
          label: '垂直商业公司',
        },
        {
          value: '城市商业公司',
          label: '城市商业公司',
        },
        {
          value: '战略商业公司',
          label: '战略商业公司',
        },
      ],
      staffList: [],
      type: {
        A: 'warning',
        Y: 'success',
        N: 'danger',
      },
      approveStateObj: {
        A: '待审批',
        Y: '合格',
        N: '不合格',
      },
      approveState:''
    };
  },
  computed: {},
  created() {
    this.getOrganisation();
    if (this.$route.query.guid) {
      this.txt = '编辑资料';
      // this.getFranchiseeDetail();
      this.getFranchiseeDetail(this.$route.query.guid, () => {
        this.showSalesman();
      });
    } else {
      this.reset();
      if (this.$route.query.tenantGuid) {
        // this.ruleForm.tenantGuid = this.$route.query.tenantGuid;
        this.getStaffList(this.$route.query.tenantGuid);
      }
    }
    if(this.$route.query.isAudit){
      this.approveState=this.$route.query.approveState||''
    }
    this.getTenantOperationRelList(false);
    this.areaData = [];
  },
  methods: {
    closeAudit(state){
      this.$router.go(-1)
      // this.approveState=state
      // this.$forceUpdate()
    },
    toAudit() {
      this.$root.$emit('auditDialog', {
        auditDialogVisible: true,
        title:'审批',
        // type,
        approveGuidList: [this.$route.query.approveGuid],
      });

    },
    getStaffList(tenantGuid) {
      // this.api
      //   .get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + tenantGuid)
      //   .then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.staffList = res.data.data;
      //     } else {
      //       this.$message.error(res.data.data.msg);
      //     }
      //   });
    },
    showMap() {
      this.dialogVisible = true;
    },
    getMarkers(marker) {
      this.dialogVisible = false;
      this.ruleForm.markers = marker;
      this.ruleForm.addressList = [marker.province, marker.city, marker.district];
      this.ruleForm.address = marker.address;
      // 程序化回填addressList不会触发票联change,需同步重算venue,否则提交的venue仍是旧区域
      let venue = '';
      if (marker.province) {
        venue = this.province(marker.province);
      }
      if (marker.city) {
        venue = this.province(marker.province) + '/' + this.city(marker.city);
      }
      if (marker.district) {
        venue = this.province(marker.province) + '/' + this.city(marker.city) + '/' + this.district(marker.district);
      }
      this.ruleForm.venue = venue;
      console.log('markermarker', marker);
    },
    close() {
      this.dialogVisible = false;
    },
    getFranchiseeDetail(guid, callBack) {
      let self = this;
      self.staffDetail = '';
      self.defaultCheckedKeys = [];
      self.api
        .postJson(`/${serverConfig.msCustomerService}/franchisee/data/get-detail?` + `guid=` + this.$route.query.guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffDetail = res.data.data;
            let marker = {
              lat: self.staffDetail.lat,
              lng: self.staffDetail.lng,
            };
            console.log(self.ruleForm.markers);
            let date = self.$moment(self.staffDetail.inputDate).format('YYYY-MM-DD');
            self.ruleForm = {
              tenantGuid: self.staffDetail.tenantGuid,
              franchiseeName: self.staffDetail.franchiseeName,
              createUserId: self.staffDetail.createUserId,
              property: self.staffDetail.property,
              region: self.staffDetail.region,
              province: self.staffDetail.province,
              city: self.staffDetail.city,
              district: self.staffDetail.district,
              venue: self.staffDetail.venue,
              address: self.staffDetail.address,
              contacts: self.staffDetail.contacts,
              contactTel: self.staffDetail.contactTel,
              lng: self.staffDetail.lng,
              lat: self.staffDetail.lat,
              inputDate: date,
              addressList: [self.staffDetail.province, self.staffDetail.city, self.staffDetail.district],
              markers: marker,
              venue: self.staffDetail.venue,
              bizState: self.staffDetail.bizState,
            };
            self.getStaffList(self.ruleForm.tenantGuid);
            self.customerGuids.push(self.staffDetail.guid);
            //执行函数
            if (callBack) {
              callBack();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    showSalesman(val) {
      let self = this;
      let query = {
        customerGuids: self.customerGuids,
        pageIndex: this.page.pageIndex,
        // 要把列表所有数据获取到
        pageSize: 10000,
      };

      self.api.postJson(`/${serverConfig.msCustomerService}/franchisee/get-belong-staff`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.belongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
          this.changebelongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
        } else {
          self.$message.error(res.data.data.msg);
        }
      });
    },
    reset() {
      this.txt = '添加资料';
      this.ruleForm = {
        franchiseeName: '',
        createUserId: '',
        property: '',
        region: '',
        province: '',
        city: '',
        district: false,
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        venue: '',
        bizState: 'Y', //启用状态
      };
      this.belongStaffList =  [];
      this.changebelongStaffList = []
      if(this.$refs.refMap){
        this.$refs.refMap.locationSearch=null
        this.$refs.refMap.searchList=[]
        this.$refs.refMap.mapType= 'bdMap'
        this.$refs.refMap.changeMap('bdMap')
      }
      if(this.$refs.choosePerson){
        this.$refs.choosePerson.departmentList=[]
      }
    },
    incres(area) {
      const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.ruleForm.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    checkName() {
      let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
      if (this.ruleForm.franchiseeName) {
        if (!patrn.test(this.ruleForm.franchiseeName)) {
          // 如果包含特殊字符返回false
          this.$message.error('商业公司名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }else{
          this.existsCheckBlur('2')
        }
      }
    },
    submitForm(formName, flg) {
      let self = this;
      if (this.ruleForm.franchiseeName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.franchiseeName)) {
          // 如果包含特殊字符返回false
          self.$message.error('商业公司名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }
      }
      if (this.$NameCheck(this, this.ruleForm.contacts, 'contacts')) {
        // todo 姓名长度校验
        return;
      }

      // if(this.ruleForm.contactTel){
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/ ;
      //   if(!regs.test(this.ruleForm.contactTel)){
      //     this.$message.error('手机号格式不正确！')
      //     return
      //   }
      // }
      let createUserName = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
          }
        });
      }
      if (self.ruleForm.addressList[0] == self.ruleForm.addressList[1] && self.ruleForm.addressList[0]) {
        this.$message.error('所属区域不能为空!');
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            tenantGuid: self.ruleForm.tenantGuid,
            franchiseeName: self.ruleForm.franchiseeName,
            createUserId: self.ruleForm.createUserId,
            createUserName: createUserName,
            property: self.ruleForm.property,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            region: self.ruleForm.region,
            contacts: self.ruleForm.contacts,
            venue: self.ruleForm.venue,
            bizState: self.ruleForm.bizState,
            contactTel: self.ruleForm.contactTel,
            lng: this.ruleForm.markers.lng,
            lat: this.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            belongStaffs: this.changebelongStaffList,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msCustomerService}/franchisee/data/pc-add`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({
                  path: '/commercialCompanyinquiry',
                  query: { tenantGuid: self.$route.query.tenantGuid },
                });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName, flg) {
      let self = this;
      if (this.ruleForm.franchiseeName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(this.ruleForm.franchiseeName)) {
          // 如果包含特殊字符返回false
          self.$message.error('商业公司名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }
      }

      if (this.$NameCheck(this, this.ruleForm.contacts, 'contacts')) {
        // todo 姓名长度校验
        return;
      }
      // if(this.ruleForm.contactTel){
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/ ;
      //   if(!regs.test(this.ruleForm.contactTel)){
      //     this.$message.error('手机号格式不正确！')
      //     return
      //   }
      // }
      let createUserName = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
          }
        });
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.$route.query.guid,
            tenantGuid: self.ruleForm.tenantGuid,
            franchiseeName: self.ruleForm.franchiseeName,
            createUserId: self.ruleForm.createUserId,
            createUserName: createUserName,
            property: self.ruleForm.property,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            region: self.ruleForm.region,
            venue: self.ruleForm.venue,
            bizState: self.ruleForm.bizState,
            contacts: self.ruleForm.contacts,
            contactTel: self.ruleForm.contactTel,
            lng: this.ruleForm.markers.lng,
            lat: this.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            belongStaffs: this.changebelongStaffList,
          };
          self.fullscreenLoading = true;
          self.api.put(`/${serverConfig.msCustomerService}/franchisee/data/pc-update`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({
                  path: '/commercialCompanyinquiry',
                  query: { tenantGuid: self.$route.query.tenantGuid },
                });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      let self = this;
      self.$router.push({
        path: '/commercialCompanyinquiry',
        query: { tenantGuid: self.$route.query.tenantGuid },
      });
    },
    /**
     * @param val 对应值
     * @param formObj 表单对象
     * @param fildeName 字段key
     */
    nameBlur(val, formObj, fildeName) {
      formObj[fildeName] = this.$NameCheckBlur(this, val, fildeName);
    },
    // 获取勾选的人员
    getPerson(res) {
      console.log(res);
      this.changebelongStaffList = res;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  // padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
    .approve-btn{
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
    .approve-tag{
      font-size: 12px;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 12px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>
